class NavAnimation {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getAnimate() {
    let element = this.getElement();
    return element.querySelector('.js-headerAnimate');
  }

  getHeader() {
    let element = this.getElement();
    return element.querySelector('.js-headerMain');
  }

  showHeader() {
    let headerEl = this.getElement();
    headerEl.classList.add('active');
  }

  showBg() {
    let headerEl = this.getElement();
    headerEl.style.background = '#212121';
  }

  hideAnimate(animateEl) {
    animateEl.classList.remove('Header__secondary__animate');
    animateEl.classList.add('Header__secondary__animate-out');
  }

  hideAnimateOnScroll() {
    let animateEl = this.getAnimate();

    window.addEventListener("scroll", () => {
      let scrolled = document.scrollingElement.scrollTop;
      if (scrolled > 1) {
        this.hideAnimate(animateEl);
        this.showHeader();
      } 
      if(scrolled > 100) {
        this.showBg();
      }
    });
  }

  showBgOnScroll() {
    window.addEventListener("scroll", () => {
      let scrolled = document.scrollingElement.scrollTop;

      if(scrolled > 100) {
        this.showBg();
      }
    });
    
  }

  showNavMin() {
    setTimeout(() => {
      this.showHeader();
    },500)
  }

  showNav() {
    let animateEl = this.getAnimate();

    setTimeout(() => {
      this.hideAnimate(animateEl);
      this.showHeader();
    },10000)
  }

  setEventHandlers() {
    // this.showNav();
    this.showNavMin();
    this.showBgOnScroll();
    // this.hideAnimateOnScroll();
  }

  init() {
    this.setEventHandlers();
  }
}


const NavAnimationInit = {
  init() {
    const $el = document.querySelector("header");
    if ($el) {
      const index = $el.dataset.index;
      index === 'true' ? new NavAnimation($el) : '';
    }
  },
};


export default NavAnimationInit;